import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable()
export class TranslationService {

  constructor(public translateService: TranslateService) {  }

  /**
   * Set the default application language.
   *
   * @param {string} defaultLanguage Default language
   */
  setDefaultLanguage(defaultLanguage: string): void {
    // Standing data.
    this.translateService.addLangs([defaultLanguage]);

    // This language will be used as a fallback
    // when a translation isn't found in the current language.
    this.translateService.setDefaultLang(defaultLanguage);

    /*** We need to un comment below lines if want to implement multi-language. ***/
    // const browserLang = this.translateService.getBrowserLang();
    // Match /en|ch|es|fr/
    // this.translateService.use(browserLang.match(/en/) ? browserLang : defaultLanguage);
  }

  /**
   * Return a translate message(s) as Promise<any> for the key passed as parameter.
   *
   * @param {(string | Array<string>)} key Key translated.
   * @returns {Observable<any>} Translated message(s) or and empty string when error.
   */
  getTranslatedMessage(key: string | Array<string>): Observable<any> {
    // Gets the translated value of a key (or an array of keys).
    return this.translateService.get(key);
  }
}
